import React from 'react'
import { AltValuePropositionWidget } from 'components/Widgets'

export const AltValueProposition = () => <AltValuePropositionWidget />
